import { Button } from '@/components/Button';
import CandidateMailComposeDialogs from '../components/CandidateMailComposeDialogs';
import MailActionBar from '../components/MailActionBar';
import MailRecipientField from '../components/MailRecipientField';
import MailRecipientPicker from '../components/MailRecipientPicker';
import MailSubjectBodyFields from '../components/MailSubjectBodyFields';
import TemplateInsertMenu from '../components/TemplateInsertMenu';
import VariableInsertMenu from '../components/VariableInsertMenu';
import useCandidateMailComposer from '../hooks/useCandidateMailComposer';
import useCandidateMailNavigation from '../hooks/useCandidateMailNavigation';
import useCandidateRecipientSelection from '../hooks/useCandidateRecipientSelection';

export default function CandidateMailComposeTemplate() {
  const navigation = useCandidateMailNavigation();
  const recipientSelection = useCandidateRecipientSelection();
  const composer = useCandidateMailComposer({
    recipients: recipientSelection.recipients,
    onFinished: (destination) => void navigation.openFolder(destination),
  });
  const isInteractionLocked = !composer.isSenderConfigured;

  return (
    <>
      <div className="flex min-h-[calc(100vh-60px)] w-full flex-col gap-md bg-gray p-lg pb-[94px]">
        <MailRecipientField
          selection={recipientSelection}
          variant="picker"
          disabled={isInteractionLocked}
        />

        <MailSubjectBodyFields
          subject={composer.subject}
          onSubjectChange={composer.setSubject}
          body={composer.body}
          onBodyChange={composer.setBody}
          bodyEditorRef={composer.bodyEditorRef}
          disabled={isInteractionLocked}
          className="min-h-[460px] flex-1"
        />
      </div>

      <MailActionBar
        start={
          <>
            <VariableInsertMenu
              onInsert={(token) => composer.bodyEditorRef.current?.insert(token)}
              disabled={isInteractionLocked}
            />
            <TemplateInsertMenu
              templates={composer.templates}
              emptyMessage={composer.templateMenuMessage}
              onSelect={composer.selectTemplate}
              disabled={isInteractionLocked}
            />
          </>
        }
        end={
          <>
            <Button
              type="button"
              color="secondary"
              size="md"
              onClick={() => void navigation.openFolder('sent')}
            >
              キャンセル
            </Button>
            <Button
              type="button"
              color="primary"
              size="md"
              disabled={composer.isPreviewDisabled}
              onClick={composer.openPreview}
            >
              プレビューで確認
            </Button>
          </>
        }
      />

      <MailRecipientPicker selection={recipientSelection} />
      <CandidateMailComposeDialogs
        composer={composer}
        onCancelSenderSetting={() => void navigation.openFolder('sent')}
      />
    </>
  );
}
